export default "__VITE_ASSET__87JVOLCQ__"